var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"download"}},[_c('div',{staticClass:"main"},[_c('button',{on:{"click":function($event){return _vm.downloadClick()}}})]),(_vm.isWeixin)?_c('div',{staticClass:"is_weixin"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }